/** @jsx h */
import { h } from 'preact'

const LinkIcon = () => {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12'>
      <g fill='currentColor'>
        <path d='M11.257 0H7.132a.74.74 0 000 1.479h2.34L5.57 5.382a.734.734 0 00-.217.523.735.735 0 00.74.739.735.735 0 00.523-.216l3.903-3.903v2.34a.74.74 0 001.479 0V.738a.74.74 0 00-.74-.739z' />
        <path d='M8.499 10.73H1.268V3.497h5.438L7.974 2.23H.634A.634.634 0 000 2.864v8.499c0 .35.284.634.634.634h8.499c.35 0 .633-.284.633-.634v-7.34L8.5 5.291v5.438z' />
      </g>
    </svg>
  )
}

export default LinkIcon
